const getLangValue = (list, lang) => {
    const target = list.find((item) => {
        return item.lang === lang;
    });
    return target ? target.value : '';
};

export default getLangValue;
